/**
 * Safely cast a string to a hex string type
 * @param value The string to cast
 * @returns The hex string or undefined if invalid
 */
export const asHexString = (value: string | undefined): `0x${string}` | undefined => {
  if (!value?.startsWith('0x')) return undefined
  return value as `0x${string}`
}
